"use client"

import { externalAppId } from "@/config/consts"
import { useConfigParams } from "@/hooks/use-config-params"
import { postLoginRedirect } from "@/lib/postLoginRedirect"
import { Translate } from "../translate"
import { Button, ButtonProps } from "../ui/button"

export function BaseCloseButton({ onClick, ...rest }: ButtonProps) {
  const { channel, cancelCallbackUrl } = useConfigParams()

  const handleClick = () => {
    if (cancelCallbackUrl == null) {
      throw new Error("cancelCallbackUrl is not defined")
    }
    postLoginRedirect(cancelCallbackUrl)
  }

  if (externalAppId.includes(channel)) return null

  return (
    <Button onClick={onClick ?? handleClick} {...rest} variant="ghost">
      <Translate i18nKey={"SiteHeader.closeBtn"} />
    </Button>
  )
}
